import type { FC } from "react";

interface DetailFieldProps {
  label: string;
  value: string | null;
}

const DetailField: FC<DetailFieldProps> = ({ label, value }) => {
  return (
    <div className="text-sm">
      <p className="text-gray-400">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
};

export default DetailField;
